import React, { FC } from 'react';
import { GlobalStylesHTML } from 'src/components/GlobalStyles';
import { useSelector, RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { RatingAnswerSurveyStyles } from './initStyles';

const MultipleChoiceSurveyHTML: FC = () => {
  const templateId = useSelector(
    (state: RootState) => state.template.templateId
  );

  const templateTitle = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  const hash = useSelector((state: RootState) => state.imageUpload.hash);
  const starIndex = useSelector(
    (state: RootState) => state.imageUpload.starIndex
  );
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const logCustom = useSelector(
    (state: RootState) => state.trackings.logCustom
  );

  const style = `
    .root_view {
      .close_btn {
        background-image: url(${bgImage?.close?.[0]});
      }
      .back_btn {
        opacity: 0;
        background-image: url(${bgImage?.back?.[0]});
      }
    }

    .root_view_0201,
    .root_view_0202,
    .root_view_0301 {
      display: none;
    }
  `;

  const html = `
    <div class="liquid">
      <p class="user_id">{{\${user_id}}}</p>
      <p class="email_address">{{\${email_address}}}</p>
      <p class="first_name">{{\${first_name}}}</p>
      <p class="last_name">{{\${last_name}}}</p>
    </div>
    <div class="root_view">
      <div class="template">
        <div class="center_horizon close">
          <button></button>
        </div>
        <div class="center_wrapper">
          <div class="logo">
            <button></button>
          </div>
          <div class="title">
            <div class="title_inner">
              ${changeEnterHTML(text?.title?.[0])}
            </div>
          </div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.sub_title?.[0])}
            </div>
          </div>
          <div class="star_wrapper">
            ${[...Array(5)]
              .map(
                (_, idx) => `
                <div id="${idx}" class="star_inner star_${idx}">
                  <button></button>
                </div>
              `
              )
              .join('')}
          </div>
        </div>
        <div class="center_horizon bottom">
          <button class="button button_0101">
            ${btnText?.button?.[0]}
          </button>
        </div>
      </div>
    </div>

    <div class="root_view root_view_0201">
      <div class="template">
        <div class="center_horizon close">
          <button></button>
        </div>
        <div class="center_wrapper">
          <div class="logo">
            <button></button>
          </div>
          <div class="title">
            <div class="title_inner">
              ${changeEnterHTML(text?.title_0201?.[0])}
            </div>
          </div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.sub_title_0201?.[0])}
            </div>
          </div>
          <div class="star_wrapper">
            ${[...Array(5)]
              .map(
                (_, idx) => `
                <div id="${idx}" class="star_inner star_${idx}">
                  <button></button>
                </div>
              `
              )
              .join('')}
          </div>
          <div class="survey_wrapper">
            <div class="survey_inner">
              ${btnText?.option_button_0201?.[0]
                ?.map(
                  (text: string, idx: number) => `
                    <span id="${idx}" class="survey survey_${idx}">
                      ${text}
                    </span>
                  `
                )
                .join('')}
            </div>
          </div>
        </div>
        <div class="center_horizon bottom">
          <button class="button button_0201">
            ${btnText?.button_0201?.[0]}
          </button>
        </div>
      </div>
    </div>

    <div class="root_view root_view_0202">
      <div class="template">
        <div class="center_horizon close">
          <button></button>
        </div>
        <div class="center_wrapper">
          <div class="logo">
            <button></button>
          </div>
          <div class="title">
            <div class="title_inner">
              ${changeEnterHTML(text?.title_0202?.[0])}
            </div>
          </div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.sub_title_0202?.[0])}
            </div>
          </div>
          <div class="star_wrapper">
            ${[...Array(5)]
              .map(
                (_, idx) => `
                <div id="${idx}" class="star_inner star_${idx}">
                  <button></button>
                </div>
              `
              )
              .join('')}
          </div>
          <div class="cta_button">
            <button class="button" onclick="window.location = '${
              deeplink?.cta_button_0202
            }'">
              ${btnText?.cta_button_0202?.[0]}
            </button>
          </div>
        </div>
        <div class="center_horizon bottom">
          <button class="button button_0202 action">
            ${btnText?.button_0202?.[0]}
          </button>
        </div>
      </div>
    </div>

    <div class="root_view root_view_0301">
      <div class="template">
        <div class="center_horizon close">
          <button></button>
        </div>
        <div class="center_wrapper">
          <div class="logo">
            <button></button>
          </div>
          <div class="title">
            <div class="title_inner">
              ${changeEnterHTML(text?.title_0301?.[0])}
            </div>
          </div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.sub_title_0301?.[0])}
            </div>
          </div>
          <div class="star_wrapper">
            ${[...Array(5)]
              .map(
                (_, idx) => `
                <div id="${idx}" class="star_inner star_${idx}">
                  <button></button>
                </div>
              `
              )
              .join('')}
          </div>
          <textarea
            class="textarea"
            placeholder="${btnText?.text_area_0301?.[0]}"
          ></textarea>
        </div>
        <div class="center_horizon bottom">
          <button class="button button_0301 action">
            ${btnText?.button_0301?.[0]}
          </button>
        </div>
      </div>
    </div>
  `;

  const js = `
    document.addEventListener("DOMContentLoaded", function() {
      let lastPage = 3;
      let currentBranchIndex = '0101';
      let starIdx = -1;
      let starIndex = ${starIndex + 1};

      let text = ${JSON.stringify(text)};
      let btnText = ${JSON.stringify(btnText)};

      <!-- 별 옵션선택 -->
      $('.star_inner').click(function() {
        if (currentBranchIndex !== '0101') return;
        starIdx = $(this).attr('id');
        $('.star_inner').removeClass('action');
        for (let i = 0; i < 5; i++) {
          if (i <= starIdx) $('.star_' + i).addClass('action');
        }
        $('.button_0101').addClass('action');
      });

      <!-- 옵션선택 -->
      let idx = -1;
      let pre_answer = [];
      $('.survey').click(function() {
        idx = $(this).attr('id');
        let action = $('.survey_' + idx).hasClass('action');
        if (action) {
          pre_answer = pre_answer.filter((data) => data !== idx);
          $('.survey_' + idx).removeClass('action');
        } else {
          pre_answer.push(idx);
          $('.survey_' + idx).addClass('action');
        }

        if (pre_answer.length === 0) $('.button_0201').removeClass('action');
        else $('.button_0201').addClass('action');
      });

      let tracking = ${JSON.stringify(tracking)};
      let button1 = ${JSON.stringify(button1)};
      let button2 = ${JSON.stringify(button2)};
      let logCustom = ${JSON.stringify(logCustom)};

      <!-- 닫기 -->
      $('.close').click(function() {
        let branchType = currentBranchIndex === '0101'? '' : '_' + currentBranchIndex;
        brazeBridge.logClick(tracking["close" + branchType][0]);

        try {
          if (button1["close" + branchType].indexOf(0) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2["close" + branchType].indexOf(0) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        brazeBridge.closeMessage();
      });

      <!-- 앞으로가기 -->
      $('.button').click(function() {
        if (starIdx === -1) return;

        let branchType = currentBranchIndex === '0101'? '' : '_' + currentBranchIndex;
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking["button" + branchType][0]);

        <!-- button 트래킹 -->
        try {
          if (button1["button" + branchType].indexOf(0) !== -1) {
            brazeBridge.logClick('0');
          }
          if (button2["button" + branchType].indexOf(0) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        let currentPage = Number(currentBranchIndex?.[0] + currentBranchIndex?.[1]);
        if (currentPage === lastPage) {
          <!-- 3page -> last -->

          <!-- liquid 값 -->
          let user = {};
          user.user_id = $('.user_id').text();
          user.email = $('.email_address').text();
          user.first_name = $('.first_name').text();
          user.last_name = $('.last_name').text();

          let answer = [];
          if (starIdx < starIndex) {
            answer.push({
              user_id: user.user_id,
              question: text.title_0201[0],
              selected: [],
            });
            for (let i = 0; i < pre_answer.length; i++) {
              answer[0].selected.push(btnText.option_button_0201[0][pre_answer[i]]);

              <!-- custom 트래킹 -->
              brazeBridge.logClick(tracking.option_button_0201[0][pre_answer[i]]);
    
              <!-- button 트래킹 -->
              try {
                if (button1.option_button_0201.indexOf(0+":"+pre_answer[i]) !== -1) {
                  brazeBridge.logClick('0');
                }
                if (button2.option_button_0201.indexOf(0+":"+pre_answer[i]) !== -1) {
                  brazeBridge.logClick('1');
                }
              } catch (err) {}
            }
          }

          let selected_text = $('.textarea').val();
          answer.push({
            user_id: user.user_id,
            question: text.title_0301[0],
            selected: [selected_text],
          });

          <!-- 설문조사 최종 값 보내기 -->
          try {
            $.ajax({
              type : 'post',
              url : '${process.env.REACT_APP_API_URL}/events',
              async : true,
              headers : {
                "Content-Type" : "application/json"
              },
              data : JSON.stringify({
                "template_id": "${templateId}" !== "undefined" ? "${templateId}" : templateId,
                "hash": "${hash}" !== "null" ? "${hash}" : hash,
                "template_name": "${templateTitle}",
                "user": user,
                "client_submit_timestamp": new Date().getTime(),
                "attributes": answer
              }),
              success : function(result) {
              },    
              error : function(request, status, error) {
              }
            })
          } catch (err) {}

          brazeBridge.closeMessage();
        } else if (currentPage === 2) {
          <!-- 2page -> 3page -->
          if (currentBranchIndex === '0201' && pre_answer.length === 0) return;
          currentBranchIndex = '0301';
        } else {
          <!-- 1page -> 2page -->
          if (starIdx < starIndex) {
            currentBranchIndex = '0201';
          }
          else {
            currentBranchIndex = '0202';
          }
        }

        $('.root_view').css('display', 'none');
        $('.root_view_' + currentBranchIndex).css('display', 'block');
      });
    });
  `;

  return (
    <>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <style
        dangerouslySetInnerHTML={{
          __html: GlobalStylesHTML() + RatingAnswerSurveyStyles() + style
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default MultipleChoiceSurveyHTML;
